<div class="checkbox-item-group" style="border-bottom: 1px solid #e3e6ea">
  <ng-template [ngIf]="data.length === selected.length" [ngIfElse]="selectAll">
    <mat-checkbox
      [checked]="true"
      (change)="onDeselectAll()"
      [color]="'primary'"
    ></mat-checkbox>
    <span class="name">Unselect All</span>
  </ng-template>

  <ng-template #selectAll>
    <mat-checkbox (change)="onSelectAll()"></mat-checkbox>
    <span class="name">Select All</span>
  </ng-template>
</div>
<div *ngFor="let item of data" class="checkbox-item-group">
  <mat-checkbox
    [checked]="selected.includes(item)"
    (change)="onCheckChange($event,item)"
    [color]="'primary'"
  ></mat-checkbox>
  <span class="name">{{item.name}}</span>
</div>
